<template>
  <div class="modal-overlay">
    <div class="modal-container" v-if="!warningModal">
      <div class="modal-body">
        <div class="modal-header">
          <img
            v-if="getUserPicture() !== ''"
            :src="getUserPicture()"
            class="user-profile"
          />
          <div v-else class="blank-image"></div>
          <img class="icon" src="../../assets/profile_verified.png" v-if="selectedUser.verified">
          <img class="icon" src="../../assets/profile_pro.png" v-if="!selectedUser.verfified && selectedUser.pro_member">
          <div class="user-details">
            <h3>{{ selectedUser.first_name.toUpperCase() }} {{ selectedUser.last_name.toUpperCase() }}</h3>
            <p>{{ selectedUser.email }}</p>
            <p>{{ age }} - {{ selectedUser.gender }}</p>
            <p>{{ selectedUser.location }}</p>
          </div>
          <i class="fas fa-times" @click="closeModal()"></i>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>BIO</label>
            <span>{{selectedUser.bio}}</span>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>LAST ACTIVE</label>
            <span>{{ formatDate(selectedUser.updated_at) }}</span>
          </div>
          <div class="modal-input">
            <label>REPORTED</label>
            <span><a :href="'/user_reports/'+selectedUser.id">{{selectedUser.reported}}</a></span>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>ACCOUNT CREATED</label>
            <span>{{ formatDate(selectedUser.created_at) }}</span>
          </div>
          <div class="modal-input">
            <label>VERIFIED SINCE</label>
            <span>{{ formatDate(selectedUser.verified_at) }}</span>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>IGNORE FROM PRO COUNT?</label>
            <ToggleButton @change="toggleIgnoreProCountClicked()" :value="selectedUser.ignore_pro_count" color="#066DCD"/>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>{{ selectedUser.explore_muted ? 'UNMUTE FROM EXPLORE?' : 'MUTE FROM EXPLORE?' }}</label>
            <ToggleButton @change="toggleExploreMutedClicked()" :value="selectedUser.explore_muted" color="#D9534F"/>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="top-row">
          <button class="secondary-btn-dark reset-password" @click="resetPassword()">
            <img class="icon" src="../../assets/reset.png">
            RESET PASSWORD
          </button>
          <button class="secondary-btn-dark" @click="changeVerify()">
            <img class="icon" src="../../assets/profile_verified.png">
            {{ selectedUser.verified ? 'UNVERIFY' : 'VERIFY' }}
          </button>
          <button class="secondary-btn-dark" :class="{'disabled': selectedUser.pro_member}" @click="givePro()" :disabled="selectedUser.pro_member">
            <img class="icon" src="../../assets/profile_pro.png">
            {{ selectedUser.pro_member ? 'ALREADY PRO' : 'GIVE PRO' }}
          </button>
        </div>
        <div class="bottom-row">
          <button @click="warnOrBanUser()" class="delete-btn ban-user">
            RESTRICT / BAN USER
          </button>
          <button @click="deleteUser()" class="delete-btn">
            DELETE USER
          </button>
        </div>
      </div>
    </div>

    <div class="modal-container" v-else>
      <div class="modal-body">
        <div class="modal-header">
          <img
            v-if="getUserPicture() !== ''"
            :src="getUserPicture()"
            class="user-profile"
          />
          <div v-else class="blank-image"></div>
          <img class="icon" src="../../assets/profile_verified.png" v-if="selectedUser.verified">
          <img class="icon" src="../../assets/profile_pro.png" v-if="!selectedUser.verfified && selectedUser.pro_member">
          <div class="user-details">
            <h3>WARN RESTRICT OR BAN USER</h3>
            <h3>{{ selectedUser.first_name.toUpperCase() }} {{ selectedUser.last_name.toUpperCase() }}</h3>
            <p>{{ formatDate(selectedUser.updated_at) }}</p>
          </div>
          <i class="fas fa-times" @click="closeModal()"></i>
        </div>
      </div>
      <div class="modal-footer">
        <div class="top-row">
          <div class="tab-option" :class="{'selected': selectedTab == 'RESTRICT'}" @click="selectedTab = 'RESTRICT'">
            RESTRICT
          </div>
          <div class="tab-option" :class="{'selected': selectedTab == 'BAN'}" @click="selectedTab = 'BAN'">
            BAN
          </div>
        </div>
        <div class="body" v-if="selectedTab == 'RESTRICT'">
          <div class="modal-input">
            <label>Type</label>
            <select v-model="restrictionType">
              <option value="" disabled>Restriction type</option>
              <option value="image_ban">Image ban</option>
            </select>
          </div>
          <div class="modal-input">
            <label>Restrict time</label>
            <select v-model="restrictionDuration">
              <option value="" disabled>Restriction duration</option>
              <option value="1_day">1 Day</option>
              <option value="1_week">1 Week</option>
              <option value="1_month">1 Month</option>
              <option value="1_year">1 Year</option>
            </select>
          </div>
          <div class="buttons">
            <button class="secondary-btn-dark" @click="closeModal()">
              CANCEL
            </button>
            <button @click="restrictUser()" class="primary-btn">
              SUBMIT
            </button>
          </div>
        </div>
        <div class="body" v-else>
          <button @click="banUser()" class="primary-btn ban-user">
            BAN USER
          </button>
        </div>
      </div>
    </div>
    <UserProPrompt v-if="proPrompt"/>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils'
import { verifyUser, resetUsersPassword, deleteUser, banUser, restrictUser, toggleIgnoreProCount, toggleExploreMuted } from '@/api/requests';
import UserProPrompt from '@/components/modals/UserProPrompt.vue';
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  name: "UserDetailModal",

  data() {
    return {
      warningModal: false,
      selectedTab: 'RESTRICT',
      restrictionType: '',
      restrictionDuration: '',
    };
  },

  components: {
    UserProPrompt,
    ToggleButton,
  },
  

  methods: {
    closeModal() {
      this.$store.dispatch('users/userDetailsClosed');
    },

    getUserPicture() {
      if (this.selectedUser.image !== "" && this.selectedUser.image !== null) {
        if (this.selectedUser.image.indexOf('blob:') > -1) {
          return this.selectedUser.image;
        }

        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + this.selectedUser.image;
      }
      return "";
    },

    formatDate(date) {
      return formatDateTime(date);
    },

    resetPassword() {
      this.$confirm(
        "Are you sure you want to reset Password for " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "?", 
        "RESET PASSWORD").then(() => {
          resetUsersPassword(this.selectedUser.email).then(() => {
            this.$toasted.global.app_success({
              message: "Users password has been reset."
            });
          }).catch(() => {
            this.$toasted.global.app_error({
              message: "Failed to reset this users password."
            });
          });
        });
    },

    changeVerify() {
      let type = this.selectedUser.verified ? 'Unverify' : 'Verify';
      this.$confirm(
        "Are you sure you want to " + type + " " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "?", 
        type.toUpperCase()).then(() => {
          let payload = {
            'verified': type === 'Verify' ? true : false
          };
          verifyUser(this.selectedUser.id, payload).then(() => {
            this.selectedUser.verified = payload['verified'];
            this.$store.dispatch('reloadTable');
            this.$toasted.global.app_success({
              message: "Users verified status has been updated."
            });
          }).catch(() => {
            this.$toasted.global.app_error({
              message: "Failed to update verified status."
            });
          });
        });
    },

    deleteUser() {
      this.$confirm(
        "Are you sure you want to delete " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "? THIS CANNOT BE UNDONE, USE WITH CAUTION!", 
        "DELETE USER").then(() => {
          deleteUser(this.selectedUser.id).then(() => {
            this.$store.dispatch('reloadTable');
            this.$store.dispatch('users/userDetailsClosed');
            this.$toasted.global.app_success({
              message: "User has been deleted."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to delete user."
          });
        });
    },

    givePro() {
      this.$store.dispatch('users/showProPrompt');
    },

    warnOrBanUser() {
      this.warningModal = !this.warningModal;
    },

    banUser() {
      this.$confirm(
        "Are you sure you want to ban " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "? They will not be able to login until unbanned!", 
        "BAN USER").then(() => {
          let payload = {
            'banned': !this.selectedUser.banned
          };
          banUser(this.selectedUser.id, payload).then(() => {
            this.$store.dispatch('reloadTable');
            this.$toasted.global.app_success({
              message: "User has been banned."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to ban user."
          });
        });
    },

    restrictUser() {
      if (this.restrictionType !== '' && this.restrictionDuration !== '') {
        this.$confirm(
          "Are you sure you want to restrict " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "?", 
          "RESTRICT USER").then(() => {
            let payload = {
              'restrict_type': this.restrictionType,
              'restrict_duration': this.restrictionDuration,
            };
            restrictUser(this.selectedUser.id, payload).then(() => {
              this.$store.dispatch('reloadTable');
              this.$toasted.global.app_success({
                message: "User has been restricted."
              });
            });
          }).catch(() => {
            this.$toasted.global.app_error({
              message: "Failed to restrict user."
            });
          });
      }
    },

    toggleIgnoreProCountClicked() {
      let payload = {
        'ignore_pro_count': !this.selectedUser.ignore_pro_count
      };
      toggleIgnoreProCount(this.selectedUser.id, payload).then(() => {
        this.$store.dispatch('reloadTable');
        this.$toasted.global.app_success({
          message: "User has been ignored from pro count."
        });
      });
    },

    toggleExploreMutedClicked() {
      let payload = {
        'explore_muted': !this.selectedUser.explore_muted
      };
      toggleExploreMuted(this.selectedUser.id, payload).then(() => {
        this.$store.dispatch('reloadTable');
        this.$toasted.global.app_success({
          message: this.selectedUser.explore_muted ? "User restored to explore feed." : "User muted from explore feed."
        });
      });
    }
  },

  computed: {
    selectedUser() {
      return this.$store.state.users.selectedUser;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },

    age() { 
      let diff_ms = Date.now() - Date.parse(this.selectedUser.birthday);
      let age_dt = new Date(diff_ms); 
    
      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },

    proPrompt() {
      return this.$store.state.users.userProPrompt;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .modal-container {
    background: $sec0;
    width: 40%;
    margin-left: 30%;
    margin-top: 150px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);

    .modal-body {
      background: $sec0;
      padding: $spacing-base;

      .modal-header {
        display: flex;
        align-items: center;
        padding-bottom: $spacing-base;

        .user-details {
          flex: 1;
          margin-left: $spacing-base;
          display: flex;
          flex-direction: column;

          h3 {
            color: #FFF;
            padding: 0;
            margin: 0;
            font-size: $font-size-medium;
            display: inline-block;
          }

          p {
            margin: 0;
            padding: 0;
            font-size: $font-size-small;
            color: $sec5;
            font-weight: bold;
            text-transform: uppercase;
          }
        }

        .blank-image {
          width: 80px;
          height: 80px;
          border-radius: 80px;
          background: $sec7;
        }

        .user-profile {
          display: inline-block;
          border-radius: 80px;
          width: 80px;
          height: 80px;
        }
        .icon {
          margin-left: -14px;
          margin-top: -50px;
        }
        i {
          color: $sec4;
          cursor: pointer;
        }
      }

      .modal-row {
        display: flex;
        margin-bottom: $spacing-base;
        gap: $spacing-small;
        label {
          display: block;
          color: $sec6;
          font-size: $font-size-x-small;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 2px;
        }

        span {
          color: $sec4;
          font-size: $font-size-small;
        }
      }

      .modal-input {
        flex: 1;

        a {
          text-decoration: none;
          color: $blue;
        }
      }
    }
  }
}

.picture-option {
  margin-left: 0;
}

.modal-footer {
  background: $sec1;
  padding: $spacing-base;
  display: flex;
  flex-direction: column;
  gap: $spacing-small;

  .secondary-btn-dark {
    border-color: #FFF;
    color: #FFF;
    font-size: $font-size-x-small;
  }

  .delete-btn {
    background: $sec0;
    color: $sec2;
    border: 0;
    border-radius: 0;
    font-weight: bold;
    height: 24px;
    font-size: $font-size-x-small;
    cursor: pointer;
  }
  
  .top-row {
    display: flex;
    button {
      flex: 1;
      border-left: 0;
    }
    .reset-password {
      flex: 2;
      border-left: 2px solid #fff;
    }
    .tab-option {
      flex: 1;
      border: 2px solid #fff;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #FFF;
      font-weight: bold;
      cursor: pointer;
    }
    .selected {
      background: $blue;
    }
  }

  .bottom-row {
    display: flex;
    button {
      flex: 1;
      border: 1px solid $sec2;
    }

    .ban-user {
      flex: 2;
      border-right: 0;
    }
  }
  button {
    // width: 45%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    i {
      display: block;
      margin-bottom: $spacing-small;
    }
    img {
      display: block;
      width: 12px;
      margin-bottom: $spacing-small / 2;
    }
  }
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.body {
  label {
    font-size: $font-size-base;
    font-weight: 500;
    color: $sec6;
    margin-bottom: $spacing-small;
    display: block;
  }

  select {
    background-color: $sec0;
    width: 100%;
    margin-bottom: $spacing-small;
  }
}
</style>